export const VendorStatuses = {
    NEW_ORDER: 1,
    TEMPLATE_REQUESTED: 2,
    SEND_TEMPLATE: 3,
    ARTWORK_RECEIVED: 4,
    PROOF_UPLOAD: 5,
    ARTWORK_APPROVED: 6,
    ON_HOLD: 7,
    IN_PRODUCTION: 8,
    EXPECTED_DISPATCHED_DATE: 9,
    IN_TRANSIT: 10,
    DELIVERED: 11,
    CANCELED: 12,
}

export const VendorStatusTitles = {
    [VendorStatuses.NEW_ORDER]: "New Order",
    [VendorStatuses.TEMPLATE_REQUESTED]: "Template Requested",
    [VendorStatuses.SEND_TEMPLATE]: "Template Sent",
    [VendorStatuses.ARTWORK_RECEIVED]: "Artwork Recieved",
    [VendorStatuses.PROOF_UPLOAD]: "Proof Sent",
    [VendorStatuses.ARTWORK_APPROVED]: "Artwork Approved",
    [VendorStatuses.ON_HOLD]: "On Hold",
    [VendorStatuses.IN_PRODUCTION]: "In Production",
    [VendorStatuses.EXPECTED_DISPATCHED_DATE]: "Expected Dispatch Date",
    [VendorStatuses.IN_TRANSIT]: "In Transit",
    [VendorStatuses.DELIVERED]: "Delivered",
    [VendorStatuses.CANCELED]: "Cancelled",
}

export const findVendorStatusTitle = (status) => VendorStatusTitles?.[status]